import {createCookie} from '../../utils/cookies';
import htmx from 'htmx.org';

export const hideBanner = () => {

  htmx.on('htmx:afterSwap', (event) => {
    if (!event.detail.target.querySelector('.banner')) {
      return
    }

    const banner = document.querySelector('.banner');

    if (!banner) {
      return
    }

    const bannerClose = banner.querySelector('.banner__close')

    bannerClose.addEventListener('click', (e) => {
      e.preventDefault()
      banner.remove()
      createCookie('isBannerHidden', '1', 1)
    })
  });
}

